import React from "react";

export const Help = () => {

    return (
        <>
            <div className="block">
                <h2>Documents à télécharger</h2>

                <ul>
                    <li><a href="https://drive.google.com/file/d/1cOL80x3UWyr3I1F4A7b4Ue8tsP5zox77/view?usp=sharing" target="_blank">Manuel utilisateur</a></li>
                    <li><a href="https://drive.google.com/file/d/14rGte_VXruBM9AsD-aQn1qVwv9mI25u2/view?usp=sharing" target="_blank">Document de sécurité</a></li>
                    <li><a href="https://drive.google.com/file/d/1XI3OE0ludgLT4E_8zrKFg3rQGHB_UXKQ/view?usp=sharing" target="_blank">Déclaration de conformité</a></li>
                </ul>
            </div>

            <div className="block">
                <h2>Contact</h2>

                <ul>
                    <li><a href="mailto:contact@handddle.com">Parler avec Handddle</a></li>
                </ul>
            </div>
        </>
    );
}